import React, { Component } from 'react';
import injectSheet from 'react-jss';

import { getClientDepartmentsTree } from '~/api/client';
import { Button } from '~/eds/src/components/Button/Button';
import { withIsSelectedHash } from '~/hocs/withIsSelectedHash';
import { withTreeNodeKeyDownHandler } from '~/hocs/withTreeNodeKeyDownHandler';
import { FormattedMessage, injectIntl } from 'react-intl';
import { TreeNode } from '~/utils/TreeNode';

import EcDepartmentTreeItem from '../../Shared/EcDepartmentTreeItem/EcDepartmentTreeItem';
import EcModalCard from '../../Shared/EcModalCard/EcModalCard';
import LoadingSpinner from '../../Shared/Icons/LoadingSpinner';
import styles from './DepartmentTreeModal.styles';

const DepartmentTreeItem = withTreeNodeKeyDownHandler(EcDepartmentTreeItem);

class DepartmentTreeModal extends Component {
  state = {
    loadingDepartments: false,
    departmentTree: null,
    departmentsSelected: this.props.departmentsSelected || [],
  };

  UNSAFE_componentWillMount() {
    const { departmentTree } = this.state;

    if (!departmentTree) this.loadClientDepartments();
  }

  loadClientDepartments() {
    const { client } = this.props;
    this.setState({ loadingDepartments: true });
    getClientDepartmentsTree(client)
      .then((res) => {
        if (res) {
          this.setState({
            departmentTree: TreeNode.fromArray(res, undefined, {
              id: 'department_id',
              name: 'department_name',
            }),
            loadingDepartments: false,
            errorLoadingDepartments: false,
          });
        }
      })
      .catch(() => {
        this.setState({
          loadingDepartments: false,
          errorLoadingDepartments: true,
        });
      });
  }

  handleDepartmentSelect = (dept, checked) => {
    const { departmentsSelected } = this.state;

    if (checked) {
      this.setState({ departmentsSelected: [...departmentsSelected, dept] });
    } else {
      const newItems = departmentsSelected.filter(
        (f) => f.department_id !== dept.department_id,
      );

      this.setState({ departmentsSelected: newItems });
    }
  };

  handleSelect = (dept) => {
    const isSelected = this.props.getIsSelected(dept.id);

    this.handleDepartmentSelect(dept.treeNode, !isSelected);
    this.props.setIsSelected(dept.id, !isSelected);
  };

  handleOnChooseDepartmentClick = () => {
    const { handleDepartmentChange, hideModal } = this.props;
    const { departmentsSelected } = this.state;

    handleDepartmentChange(departmentsSelected);
    hideModal();
  };

  renderDepartmentTree() {
    const { classes, getIsSelected, setIsSelected } = this.props;
    const {
      departmentTree,
      departmentsSelected,
      loadingDepartments,
      errorLoadingDepartments,
    } = this.state;

    if (loadingDepartments) {
      return (
        <div className={classes.loadingContainer}>
          <LoadingSpinner size="medium" />
        </div>
      );
    } else if (errorLoadingDepartments) {
      return (
        <div>
          {this.props.intl.formatMessage({
            id: 'DepartmentTreeModal.errorLoading',
            defaultMessage: 'An error occurred while loading the departments.',
            description: 'Error message when departments fail to load',
          })}
        </div>
      );
    } else if (!errorLoadingDepartments && !departmentTree?.children.length) {
      return (
        <div className={classes.noDeptMessage}>
          <FormattedMessage
            id="DepartmentTreeModal.noDepartments"
            defaultMessage={
              'No departments currently exist for your organization. {br}Create new departments from the Admin Console.'
            }
            description="Message when no departments exist"
            values={{
              br: <br />,
            }}
          />
        </div>
      );
    } else {
      return (
        <div className={classes.departmentTree}>
          <DepartmentTreeItem
            department={departmentTree}
            departmentsSelected={departmentsSelected}
            getIsSelected={getIsSelected}
            onSelect={this.handleSelect}
            setIsSelected={setIsSelected}
          />
        </div>
      );
    }
  }

  render() {
    const { title, confirmButtonText, hideModal } = this.props;
    const { departmentTree } = this.state;

    return (
      <EcModalCard
        title={title}
        content={this.renderDepartmentTree()}
        footer={
          departmentTree?.children.length > 0 && (
            <>
              <Button
                variant="tertiary"
                text={this.props.intl.formatMessage({
                  id: 'DepartmentTreeModal.cancelButton',
                  defaultMessage: 'Cancel',
                  description: 'Cancel button text',
                })}
                onClick={hideModal}
              />
              <Button
                variant="primary"
                text={confirmButtonText}
                onClick={this.handleOnChooseDepartmentClick}
              />
            </>
          )
        }
        hideModal={hideModal}
      />
    );
  }
}

export default injectSheet(styles)(
  withIsSelectedHash(injectIntl(DepartmentTreeModal)),
);
